function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.378418,
    width: 52,
    height: 52,
    rx: 6,
    fill: "#CA0C64",
    fillOpacity: 0.08,
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2496 35.4841H20.056C20.5401 35.4841 20.9874 35.2258 21.2294 34.8067C21.4715 34.3876 21.4715 33.871 21.2294 33.4519C20.9874 33.0327 20.5402 32.7744 20.056 32.7744H18.2496C17.4112 32.7744 16.607 32.4413 16.0141 31.8486C15.4214 31.2557 15.0882 30.4515 15.0882 29.6131V17.8711C15.0882 17.0327 15.4213 16.2285 16.0141 15.6356C16.607 15.0429 17.4112 14.7097 18.2496 14.7097H33.1531C33.9915 14.7097 34.7956 15.0429 35.3885 15.6356C35.9813 16.2285 36.3144 17.0327 36.3144 17.8711V18.3227C36.3144 18.8068 36.5727 19.254 36.9918 19.496C37.411 19.7381 37.9276 19.7381 38.3467 19.496C38.7658 19.254 39.0241 18.8068 39.0241 18.3227V17.8711C39.0241 16.3139 38.4055 14.8206 37.3045 13.7196C36.2036 12.6186 34.7102 12 33.153 12H18.2495C16.6924 12 15.199 12.6186 14.098 13.7196C12.997 14.8205 12.3784 16.3139 12.3784 17.8711V29.6131C12.3784 31.1703 12.9971 32.6636 14.098 33.7646C15.1989 34.8656 16.6923 35.4842 18.2495 35.4842L18.2496 35.4841Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3789 38.6452V38.4194C40.3801 37.0825 40.0407 35.7673 39.3928 34.5979C38.7448 33.4285 37.8098 32.4434 36.6757 31.7354L36.2603 31.4734L36.5584 31.0805L36.5583 31.0806C37.2801 30.1418 37.6707 28.9906 37.6693 27.8064C37.6703 26.0409 36.8111 24.3856 35.3669 23.37C33.9226 22.3544 32.0744 22.1063 30.4134 22.7045C28.7524 23.3027 27.4868 24.6725 27.0218 26.3756C26.5568 28.0787 26.9504 29.9017 28.0769 31.261L28.393 31.6403L27.9865 31.9203C26.9348 32.6471 26.0747 33.618 25.4801 34.7499C24.8855 35.8815 24.574 37.1405 24.5723 38.4191V38.6449C24.5723 39.129 24.8306 39.5762 25.2497 39.8182C25.6688 40.0603 26.1854 40.0603 26.6046 39.8182C27.0237 39.5762 27.282 39.129 27.282 38.6449V38.4191C27.282 36.5637 28.2718 34.8491 29.8788 33.9214C31.4858 32.9936 33.4655 32.9936 35.0725 33.9214C36.6794 34.8491 37.6693 36.5637 37.6693 38.4191V38.6449C37.6693 39.129 37.9276 39.5762 38.3467 39.8182C38.7658 40.0603 39.2824 40.0603 39.7016 39.8182C40.1207 39.5762 40.379 39.129 40.379 38.6449L40.3789 38.6452ZM32.2498 30.5161C31.5312 30.5161 30.8418 30.2306 30.3338 29.7224C29.8255 29.2143 29.54 28.525 29.54 27.8064C29.54 27.0878 29.8255 26.3985 30.3338 25.8904C30.8418 25.3822 31.5312 25.0967 32.2498 25.0967C32.9684 25.0967 33.6577 25.3822 34.1658 25.8904C34.674 26.3985 34.9595 27.0878 34.9595 27.8064C34.9595 28.525 34.674 29.2143 34.1658 29.7224C33.6577 30.2306 32.9684 30.5161 32.2498 30.5161Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.a7576f8af5624ed8f95d790186832c40.svg";
export { ForwardRef as ReactComponent };